// iter87.199.157 — Shared Paddle.js singleton. Paddle.Initialize() may
// only ever run ONCE per page load (Paddle's own docs) — this app is
// a client-routed SPA, so a visit to `/` (Retain's public homepage
// install, no `pwCustomer`) and a later navigation to `/rivalry-pro`
// checkout share the same `window.Paddle` instance without a full
// reload. Both call sites go through this one module so whichever
// runs first "wins" and the second reuses it instead of double-init'ing.
//
// iter87.199.157 fix: Paddle's `eventCallback` can only be supplied
// at Initialize time (or later via `Paddle.Update`), so the FIRST
// caller used to permanently own it — every later caller's `onEvent`
// was silently dropped (found by testing agent on iter87.199.156:
// Landing.jsx's homepage Retain install initializes with no
// callback, so any SPA route change into a real checkout/overlay
// never heard `checkout.completed` / `checkout.closed`). Fixed by
// keeping our OWN fan-out list of listeners and passing a single
// dispatcher as the real `eventCallback` — every `ensurePaddleInitialized`
// call registers its `onEvent` here regardless of init order.
const listeners = new Set();
let paddleInitPromise = null;

function dispatch(evt) {
    listeners.forEach((fn) => {
        try { fn(evt); } catch (_e) { /* one bad listener shouldn't break the rest */ }
    });
}

export function ensurePaddleInitialized(clientToken, environment, onEvent) {
    if (!window.Paddle) return Promise.reject(new Error("Paddle.js not loaded"));
    if (onEvent) listeners.add(onEvent);
    if (!paddleInitPromise) {
        paddleInitPromise = new Promise((resolve, reject) => {
            try {
                if (environment === "sandbox") window.Paddle.Environment.set("sandbox");
                window.Paddle.Initialize({ token: clientToken, eventCallback: dispatch });
                resolve();
            } catch (e) {
                // Don't cache a failed init — every later call would
                // silently reuse this broken promise.
                paddleInitPromise = null;
                reject(e);
            }
        });
    }
    return paddleInitPromise;
}
